import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as warningPlugin from '../../../warnings/plugin'

import * as gql from './gql'

/** Record warnings API */
@ngCore.Injectable()
export class Api implements warningPlugin.Api {
  /**
   * Gets warnings for a space record.
   */
  public get({
    context,
    entityId,
  }: warningPlugin.Api.Get.Params): rxjs.Observable<
    readonly ents.extra.space.Warning[]
  > {
    ents.extra.space.Record.Id.assertIsId(entityId)

    return gql.queries.executor({
      ...context,
      spaceRecordId: entityId,
    })
  }
}
